import type { HomeCardLayout } from "@/campaigns";
import type { PrizeSchema } from "@/types/generated-types";
import type { Tournament } from "@/campaigns/modules/tournament/types";

import { CompactCampaignCard } from "@/components/campaign-card/campaign-card-compact";
import { Flag, Trophy } from "lucide-react";
import { formatPrizeTitle } from "@/utils/helpers";
import {
  isRace,
  tournamentLabels,
} from "@/campaigns/modules/tournament/labels";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/** The grand prize — prizes are place-ranged, so lowest `place_from` is 1st. */
const topPrize = (prizes: PrizeSchema[]): PrizeSchema | undefined =>
  [...prizes].sort((a, b) => (a.place_from ?? 0) - (b.place_from ?? 0))[0];

export const TournamentHomeCard = ({
  tournament,
  layout,
}: {
  tournament: Tournament;
  layout: HomeCardLayout;
}) => {
  const { t } = useTranslation();
  const prize = useMemo(() => topPrize(tournament.prizes), [tournament.prizes]);

  return (
    <CompactCampaignCard
      campaign={tournament.campaign}
      typeLabel={tournamentLabels(tournament, t).type}
      typeIcon={isRace(tournament) ? <Flag /> : <Trophy />}
      hookValue={prize ? formatPrizeTitle(prize.title, t) : null}
      hookLabel={t("campaign.topPrize", "Top prize")}
      hookIsCatalogItem={prize?.is_catalog_item}
      layout={layout}
    />
  );
};
